import axios from 'axios';

// Runtime config (public/config.js), with dev fallbacks.
const API_BASE_URL = window.OMNIPRAC_CONFIG?.API_URL || 'http://localhost:5100/api';

// The practice database this deployment is bound to. Sent on every request so
// the backend queries the right practice's users table.
const TENANT_DB = window.OMNIPRAC_CONFIG?.TENANT_DB;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem('jwt');
    if (jwt) config.headers['Authorization'] = `Bearer ${jwt}`;
    if (TENANT_DB) config.headers['x-db-name'] = TENANT_DB;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      ['jwt', 'uid', 'uname', 'ufull_name', 'role'].forEach((k) => localStorage.removeItem(k));
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const TENANT_DB_NAME = TENANT_DB;
export default api;
